<template>
    <div
        ref="rankItemRef"
        :class="[
            'rank-item', bookInfo?.sort <= 3 && props.isRank ? `ranking-top` : '',
            props.isRank && `rank-top-${bookInfo?.sort}`,
            rankStep2 ? 'rank-step-2' : '',
            props.highId === bookInfo.book_info.book_id ? 'high-id' : ''
        ]">
        <div class="rank-item-rank" v-if="props.isRank">
            <template v-if="bookInfo?.sort <= 3">
                <div :class="[`ranking-${bookInfo?.sort}`]"></div>
            </template>
            <template v-else>
                <span class="rank-num qm-number" :class="{'rank-num-small': bookInfo?.sort >= 100}">{{ bookInfo?.sort || '-' }}</span>
            </template>
        </div>
        <div class="rank-item-content" @click="goToReader('original', false)">
            <div class="rank-title">《<span class="rank-title-text">{{ bookInfo.book_info.title }}</span>》</div>
            <div class="rank-author pdl-sm">{{ bookInfo.book_info.author }}</div>
            <!-- 二阶段投票数 -->
            <div v-if="rankStep2" class="rank-tip pdl-sm">
                <span class="vote-count qm-number">{{ bookInfo.vote_num }}</span>票
                <span class="rank-tip-text" v-show="tagText" :unknown="props.bookInfo?.book_info?.stage == 2" :pre="props.bookInfo?.book_info?.stage == 3" :done="props.bookInfo?.book_info?.stage == 4">
                    {{ tagText }}
                </span>
            </div>
        </div>
        <div class="rank-item-right">
            <div v-if="!rankStep2" @click="onVote">
                <div class="btn-vote"></div>
                <div class="rank-vote-count">
                    <span class="rank-vote-count-num qm-number">{{ bookInfo.vote_num }}</span>票
                </div>
            </div>
            <!-- TODO: 字体使用 思源黑体 -->
            <template v-else>
                <p class="rank-step-2-btn" v-if="props.bookInfo?.book_info?.stage == 2 && props.bookInfo.book_info?.fanwai_id" @click="handleAddShelfClick">{{ props.shelfBookIds.includes(props.bookInfo.book_info.fanwai_id) ? '查看详情' : '预加书架' }}</p>
                <p class="rank-step-2-btn zh-pre-btn" @click="handleZhPreClick" v-if="props.bookInfo?.book_info?.stage == 3 && !storeCommon.systemInfo.isHarmony">纵横抢先看</p>
                <p class="rank-step-2-btn zh-qm-add-btn"
                   @click="handleAddShelfClick"
                   v-if="props.bookInfo?.book_info?.stage == 3
                       && props.bookInfo.book_info?.fanwai_id
                       && !props.shelfBookIds.includes(props.bookInfo.book_info.fanwai_id)"
                >预加书架</p>
                <p class="rank-step-2-btn read-outer-btn" v-if="props.bookInfo?.book_info?.stage == 4" @click="goToReader('outer')">阅读番外</p>
                <p class="rank-step-2-btn" v-if="props.bookInfo?.book_info?.stage == 5" @click="goToReader('original')">立即阅读</p>
            </template>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, ref, onMounted, watch, nextTick } from 'vue';
import { toBookReader, addBookToShelf, jsbReportV3 } from '@q-front-npm/jsbridge';
import { apiZhUrl } from '@/http/api';
import { useStoreCommon } from '@common/store/common';
import { handleLogin } from '@common/assets/ts/utils';
import Vue from 'vue';
import { useStore } from '@/store';
import { useIntersectionObserver } from '@common/hooks/useIntersectionObserver';

const storeCommon = useStoreCommon();
const store = useStore();

const props = defineProps({
    bookInfo: {
        type: Object,
        default: () => ({}),
    },
    isRank: {
        type: Boolean,
        default: false,
    },
    shelfBookIds: {
        type: Array,
        default: () => [],
    },
    highId: {
        type: String,
        default: '',
    },
    isSearch: {
        type: Boolean,
        default: false,
    },
});

const rankStep2 = computed(() => {
    return +props.bookInfo?.book_info?.stage > 1;
});

const tagText = computed(() => {
    let text = '';
    if (props.bookInfo?.book_info?.stage == 2) {
        text = '番外待发布';
    } else if (+props.bookInfo?.book_info?.publish_time > 0 && props.bookInfo?.book_info?.stage == 3) {
        const time = +props.bookInfo?.book_info?.publish_time;
        text = `番外将在${new Date(time).getMonth() + 1}月${new Date(time).getDate()}日${new Date(time).getHours()}时发布`;
    } else if (props.bookInfo?.book_info?.stage == 4) {
        text = '番外已发布';
    }
    return text;
});

const emits = defineEmits(['vote', 'refreshBookshelf']);

const onVote = () => {
    if (!handleLogin(storeCommon.userInfo.user_type.toString())) return;
    jsbReportV3('26wish_rank_button_click', {book_id: props.bookInfo.book_info.book_id, btn_name: '投票',});
    emits('vote', props.bookInfo);
};

// 加入书架
const handleAddShelfClick = () => {
    if (props.shelfBookIds.includes(props.bookInfo.book_info.fanwai_id)){
        goToReader('outer');
        return;
    }

    jsbReportV3('26wish_rank_button_click', {book_id: props.bookInfo.book_info.book_id, btn_name: '预加书架',});

    store.setIsNeedFocus(true);
    addBookToShelf([
        {
            book_id: props.bookInfo.book_info.fanwai_id,
            book_type: '0',
            image_link: props.bookInfo.book_info.fanwai_image_link || props.bookInfo.book_info.image_link,
            title: props.bookInfo.book_info.fanwai_title || props.bookInfo.book_info.title,
        }
    ]).then((data: any) => {
        Vue.prototype.$toast('加入书架成功');
        emits('refreshBookshelf');
    });
};

// 纵横抢先看
const handleZhPreClick = () => {
    store.setIsNeedFocus(true);
    jsbReportV3('26wish_rank_button_click', {book_id: props.bookInfo.book_info.book_id, btn_name: '纵横抢先看',});
    store.goToZh(1, props.bookInfo.book_info);
};

// 阅读番外
const goToReader = (type: string, isReport: boolean = true) => {
    // 搜索页和推荐页，点击不进行跳转
    if (!isReport && props.isSearch) return;
    isReport && jsbReportV3('26wish_rank_button_click', {book_id: props.bookInfo.book_info.book_id, btn_name: type === 'outer' ? '阅读番外' : '阅读原著',});
    toBookReader({
        id: type === 'outer' ? props.bookInfo.book_info.fanwai_id : props.bookInfo.book_info.book_id,
        type: '0',
        title: props.bookInfo.book_info.fanwai_title || props.bookInfo.book_info.title,
        author: props.bookInfo.book_info.author,
        image_link: props.bookInfo.book_info.fanwai_image_link || props.bookInfo.book_info.image_link,
        reader_type: '0',
    });
};

const rankItemRef = ref<HTMLElement>();
onMounted(() => {
    nextTick(() => {
        const { targetRef, isIntersecting, disconnect, } = useIntersectionObserver({
            threshold: 0.9,
        });
        targetRef.value = rankItemRef.value as HTMLElement;
        watch(() => isIntersecting.value, (newVal) => {
            if (newVal) {
                jsbReportV3('26wish_rank_book_show', {book_id: props.bookInfo.book_info.book_id,});
                disconnect();
            }
        }, { immediate: true, once: true, });
    });
});
</script>

<style lang="scss" scoped>
.rank-item {
    display: flex;
    align-items: center;
    padding: 14px 20px 14px 12px;
    border: 4px solid transparent;
}
.rank-step-2 {
   align-items: flex-start;
   .rank-item-rank {
        margin-top: 4px;
   }
}
.ranking-top {
    padding: 14px 20px 14px 12px;
    border-radius: 22px;
    margin-bottom: 16px;
}

.rank-top-1 {
    border-color: #FFDA37;
    background: #FBEFC4;
}

.rank-top-2 {
    border-color: rgba(180, 222, 252, 0.7);
    background: rgba(242, 242, 242, 0.8);
}

.rank-top-3 {
    border-color: #FFDFA2;
    background: #FFEDCB;
    margin-bottom: 8px;
}

.rank-item-rank {
    width: 48px;
    height: 54px;
    background: url('@/assets/images/rank/ranking_rest.png') no-repeat center center;
    background-size: 100% 100%;
    text-align: center;
    margin-right: 8px;
}

.rank-num {
    font-size: 24px;
    color: rgba(17,17,17,0.6);
    font-weight: border;
    line-height: 54px;
}
.rank-num-small {
    font-size: 20px;
}

.rank-item-content {
    flex: 1;
    min-width: 0;
    padding-right: 16px;
}

.rank-title {
    font-weight: 600;
    font-size: 28px;
    color: rgba(17,17,17,0.8);
    line-height: 40px;
    font-weight: bold;
    display: flex;
    align-items: center;
    .rank-title-text {
        max-width: 320px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}

.rank-author {
    font-size: 22px;
    color: rgba(17,17,17,0.5);
    line-height: 32px;
}

.rank-item-right {
    // flex-shrink: 0;
    // display: flex;
    // flex-direction: column;
    // align-items: center;
    // justify-content: center;
    // height: 100%;
    margin: auto;
}

.rank-vote-btn {
    width: 116px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    background: url('@/assets/images/rank/ranking_rest.png') no-repeat center center;
    background-size: 100% 100%;
}
.rank-vote-count {
    font-weight: bold;
    font-size: 22px;
    color: #440A0A;
    line-height: 24px;
    text-align: center;
    margin-top: 6px;
    .rank-vote-count-num {
        margin-right: 2px;
        font-weight: normal;
    }
}
.pdl-sm {
    padding-left: 10px;
}

.rank-tip {
    font-weight: bold;
    font-size: 20px;
    color: #666666;
    line-height: 24px;
    margin-top: 8px;
    display: flex;
    align-items: center;
    .vote-count {
        margin-right: 2px;
        font-size: 22px;
    }
    .rank-tip-text {
        font-weight: normal;
        border-radius: 6px;
        height: 28px;
        line-height: 28px;
        padding: 0 6px;
        color: #342E1A;
        margin-left: 8px;
        font-size: 17px;
        white-space: nowrap;
        font-weight: bold;
        margin-top: -1px;
        &[unknown] {
            background: linear-gradient( 57deg, #76FCD4 0%, #DEE333 50.32%, #FFDB00 100%);
        }
        &[pre] {
            background: linear-gradient( 72deg, #FFEC49 0%, #FFDB00 100%);
        }
        &[done] {
            background: linear-gradient( 74deg, #FF560A 0%, #FF8441 100%);
            color: #fff;
        }
    }
}
.rank-step-2-btn {
    font-weight: bold;
    font-size: 21px;
    color: #FFF5D3;
    padding: 14px 18px;
    border-radius: 24px;
    background: linear-gradient( 270deg, #FF6139 0%, #FF551D 47.37%, #FF3A00 100%);
    &:not(:last-child) {
        margin-bottom: 12px;
    }
}
.zh-pre-btn, .read-outer-btn {
    background: linear-gradient( 270deg, #FFB100 0%, #FF9A00 32.02%, #FF7600 100%);
}
.zh-qm-add-btn {
    background: rgba(255,235,199,0.6);
    border-radius: 28px;
    border: 0.5px solid #FFC35C;
    color: #FCA000;
    text-align: center;
}
.not-rank {
    padding-left: 20px;
}
.high-id {
    // animation: high-id .5s infinite;
    background: #FFF9E5!important;
    border-radius: 12px;
}
@keyframes high-id {
    0%, 100% {
        opacity: 0.8;
    }
    50% {
        opacity: 1;
    }
}
</style>
